<div class="is-flex is-justified-center loader-container">
    <loader />
</div>
<div class="is-flex columns is-justified-center">
    <div class="has-text-centered">
        <h1 class="title">{{ title }}</h1>
        <p class="subtitle">{{ subtitle }}</p>

        <div>
            <button class="button is-conversion" (click)="goToPayment()">J'y vais</button>
        </div>
    </div>
</div>
